// Revisado: 2025-12-18 [I18n Scan]
/**
 * Calculates the score for the Unique Skill based on character stars and skill level.
 * 
 * Logic:
 * - Stars 1-2: 120 score per level
 * - Stars 3-5: 170 score per level
 * 
 * @param {number} stars - The current star rating of the character (1-5)
 * @param {number} level - The level of the unique skill (1-6 usually)
 * @returns {number} The calculated score
 */
export const calculateUniqueSkillScore = (stars, level) => {
    if (!stars || !level) return 0;

    const scorePerLevel = stars >= 3 ? 170 : 120;
    return scorePerLevel * level;
};
// Revisado: 2025-12-16
